import { fetchData } from '@eliadmin/core/src/api/fetcher';
import {
  buildStoreListRequest,
  storeApiResources,
} from '@eliadmin/core/src/api/store-list-request';
import type { ManufacturerIndex } from '@eliadmin/core/src/api/manufacturers/types/manufacturers-types';

export async function fetchPrinterManufacturers(
  locale: string,
  options: {
    parents?: (number | string)[];
    ids?: (number | string)[];
    search?: string;
    page?: number;
    results?: number;
  } = {},
  signal?: AbortSignal,
) {
  const { parents, ids, search = '', page = 1, results = 48 } = options;
  return fetchData<{
    data: ManufacturerIndex[];
    meta: { current_page: number; last_page: number; total: number };
  }>({
    ...buildStoreListRequest(storeApiResources.storeManufacturers, {
      where:
        parents?.length || ids?.length
          ? {
              ...(parents?.length ? { parent: { in: parents } } : {}),
              ...(ids?.length ? { id: { in: ids } } : {}),
            }
          : undefined,
      query: { search, page, results },
    }),
    locale,
    signal,
  });
}
